module.exports = __webpack_public_path__ + "img/clinicimg4.ad0aa574.jpg";